const presets = [
  {
    name: 'Keynote',
    hidden: ['thickness', 'blend', 'resolution'],
    defaults: {
      blend: 'multiply',
      brightness: 50,
      contrast: 50,
      thickness: 13,
      color: '#e22a1D',
      resolution: {
        width: 1920,
        height: 1080,
      },
    },
  },
  {
    name: 'Custom',
    hidden: [],
    defaults: {
      blend: 'multiply',
      brightness: 50,
      contrast: 50,
      thickness: 13,
      color: '#e22a1D',
    },
  },
];

export const PRESET_NAMES = presets.map(p => p.name);
export const getPreset = name => presets.find(p => p.name === name);
export const getDefaultPreset = () => presets[0];
export default presets;



// WEBPACK FOOTER //
// /opt/build/repo/src/app/config/presets.js